/**
 * 格式化时间
 * @param dateString 字符串日期
 * @param type  格式类型 1：年月日 2：时分秒
 * @returns {undefined|string}
 */
export function formattedDate(dateString, type=1) {
  const dateObject = new Date(dateString);

  // 获取日期部分
  const year = dateObject.getFullYear();
  const month = padZero(dateObject.getMonth() + 1);
  const day = padZero(dateObject.getDate());
  const hours = padZero(dateObject.getHours());
  const minutes = padZero(dateObject.getMinutes());
  const seconds = padZero(dateObject.getSeconds());

  // 构建日期字符串
  const formattedDate = type === 1 ?
    year + '-' + month + '-' + day :
    type === 2 ?
    year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds : undefined

  return formattedDate
}

function padZero(number) {
// 补零函数，确保单个数字的月、日、时、分、秒都有两位
  return (number < 10 ? '0' : '') + number;
}
